module.exports = __webpack_public_path__ + "static/media/asphalt.bf313a98.jpg";